module.exports = __webpack_public_path__ + "img/bz.e7e7013.svg";